import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "@context/AuthContext";
import axios from "axios";
import { API_BASE, PROFILE_IMG_BASE } from "@config/env";


const post = (ep, f) => { const fd=new FormData(); Object.entries(f).forEach(([k,v])=>{ if(v!=null) fd.append(k,v); }); return axios.post(`${API_BASE}${ep}`,fd).then(r=>r.data).catch(()=>null); };
const JOB_TYPES = [{ value:"1",label:"Full-time" },{ value:"2",label:"Part-time" },{ value:"3",label:"Contract" },{ value:"4",label:"Permanent" }];

function Field({ label, required, children }) {
  return (
    <div style={{ marginBottom:16 }}>
      <label style={{ fontSize:11, fontWeight:700, color:"var(--fc-text-secondary)", display:"block", marginBottom:5, textTransform:"uppercase", letterSpacing:"0.05em" }}>{label}{required&&" *"}</label>
      {children}
    </div>
  );
}
const inp = (value, onChange, placeholder, type="text") => (
  <input type={type} value={value||""} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
    style={{ width:"100%", boxSizing:"border-box", padding:"10px 12px", border:"1.5px solid var(--fc-border)", borderRadius:9, fontSize:13, outline:"none", fontFamily:"inherit", color:"var(--fc-text-primary)", background:"var(--fc-card-bg)", transition:"all 0.18s" }}
    onFocus={e=>{e.target.style.borderColor="#2563EB";e.target.style.boxShadow="0 0 0 3px rgba(79,70,229,0.1)"}}
    onBlur={e=>{e.target.style.borderColor="var(--fc-border)";e.target.style.boxShadow="none"}} />
);
const ta = (value, onChange, placeholder, rows=4) => (
  <textarea value={value||""} onChange={e=>onChange(e.target.value)} placeholder={placeholder} rows={rows}
    style={{ width:"100%", boxSizing:"border-box", padding:"10px 12px", border:"1.5px solid var(--fc-border)", borderRadius:9, fontSize:13, outline:"none", fontFamily:"inherit", color:"var(--fc-text-primary)", background:"var(--fc-card-bg)", resize:"vertical", transition:"all 0.18s" }}
    onFocus={e=>{e.target.style.borderColor="#2563EB"}} onBlur={e=>{e.target.style.borderColor="var(--fc-border)"}} />
);

export default function EditJobPage() {
  const { id }       = useParams();
  const navigate     = useNavigate();
  const { userSlug } = useAuth();

  const [loading,   setLoading]   = useState(true);
  const [noAccess,  setNoAccess]  = useState(false);
  const [firmList,  setFirmList]  = useState([]);
  const [selFirms,  setSelFirms]  = useState([]);
  const [busy,      setBusy]      = useState(false);
  const [success,   setSuccess]   = useState("");
  const [error,     setError]     = useState("");

  const [form, setForm] = useState({
    jobTitle:"", description:"", skills:"", experience:"",
    jobType:"1", contractLength:"", compensation:"", locationReq:"",
    other:"", employerName:"", employerDesc:"", benefits:"",
    workingHours:"", closingDate:"", jobRequirements:"",
    applicationDetails:"", employerContact:"", employerWebsite:"",
    jobSlug:"",
  });
  const set = (k, v) => setForm(f=>({...f,[k]:v}));

  useEffect(() => {
    if (!id || !userSlug) return;
    Promise.all([
      post("get-job-edit-details", { user_slug: userSlug, job_slug: id }),
      post("get-all-firm-access-list", { user_slug: userSlug }),
    ]).then(([jobData, firmData]) => {
      const j = jobData?.job_details;
      if (!j) { setNoAccess(true); setLoading(false); return; }
      setForm({
        jobTitle:          j.job_title || "",
        description:       j.job_description || "",
        skills:            j.required_skill_set || "",
        experience:        j.experience_required || "",
        jobType:           j.job_type || "1",
        contractLength:    j.contract_length || "",
        compensation:      j.compensation || "",
        locationReq:       j.location_requirement || "",
        other:             j.other || "",
        employerName:      j.employer_name || "",
        employerDesc:      j.employer_description || "",
        benefits:          j.benefits || "",
        workingHours:      j.working_hours || "",
        closingDate:       j.closing_date ? j.closing_date.split("T")[0] : "",
        jobRequirements:   j.job_requirements || "",
        applicationDetails:j.application_details || "",
        employerContact:   j.employer_contact || "",
        employerWebsite:   j.employer_website || "",
        jobSlug:           j.job_slug || id,
      });
      const fList = firmData?.firmList || firmData?.data?.firmList || [];
      setFirmList(Array.isArray(fList) ? fList : []);
      const access = (j.job_firm_access||"").split(",").map(s=>s.trim()).filter(Boolean);
      setSelFirms(access.length > 0 ? access : fList.map(f=>String(f.firm_id)));
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [id, userSlug]);

  const toggleFirm = (fid) => setSelFirms(s => s.includes(String(fid)) ? s.filter(x=>x!==String(fid)) : [...s, String(fid)]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.jobTitle.trim()) { setError("Job title is required"); return; }
    setBusy(true); setError("");
    const res = await post("update-job", {
      user_slug: userSlug, job_slug: form.jobSlug,
      job_title: form.jobTitle, job_description: form.description,
      firm_ids: selFirms.join(","),
      required_skill_set: form.skills, experience_required: form.experience,
      job_type: form.jobType, contract_length: form.contractLength,
      compensation: form.compensation, location_requirement: form.locationReq,
      other: form.other, employer_name: form.employerName,
      employer_description: form.employerDesc, benefits: form.benefits,
      working_hours: form.workingHours, closing_date: form.closingDate,
      job_requirements: form.jobRequirements, application_details: form.applicationDetails,
      employer_contact: form.employerContact, employer_website: form.employerWebsite,
    });
    setBusy(false);
    if (res?.status === 1) setSuccess(res.message || "Job updated successfully!");
    else setError(res?.message || "Failed to update job.");
  };

  if (loading) {
    return (
      <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
        {[1,2,3].map(i => <div key={i} style={{ height:80, background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:14 }} />)}
      </div>
    );
  }
  if (noAccess) {
    return (
      <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:14, padding:"48px 24px", textAlign:"center" }}>
        <div style={{ fontSize:15, fontWeight:700, color:"var(--fc-text-primary)" }}>Access Denied</div>
        <div style={{ fontSize:13, color:"var(--fc-text-subtle)", marginTop:4 }}>You don't have permission to edit this job.</div>
      </div>
    );
  }
  if (success) {
    return (
      <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:16, padding:"48px 24px", textAlign:"center", maxWidth:500, margin:"0 auto" }}>
        <div style={{ width:52, height:52, borderRadius:14, background:"var(--fc-green-light)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px" }}>
          <i className="fa-solid fa-circle-check" style={{ fontSize:22, color:"var(--fc-green)" }} />
        </div>
        <h2 style={{ fontSize:18, fontWeight:700, color:"var(--fc-text-primary)", marginBottom:8 }}>Job Updated!</h2>
        <p style={{ fontSize:13, color:"var(--fc-text-muted)", marginBottom:24 }}>{success}</p>
        <button onClick={()=>navigate(`/job/details/${form.jobSlug}`)} className="fc-btn fc-btn-sm fc-btn-primary fc-btn-pill">View Job</button>
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <button onClick={()=>navigate(-1)} style={{ background:"none", border:"none", cursor:"pointer", color:"var(--fc-text-muted)", fontSize:13, padding:0, display:"flex", alignItems:"center", gap:6, marginBottom:8, fontFamily:"inherit" }}>
          <i className="fa-solid fa-arrow-left" style={{fontSize:11}} /> Back
        </button>
        <h1 style={{ fontSize:20, fontWeight:800, color:"var(--fc-text-primary)", margin:0 }}>Edit Job</h1>
        <p style={{ fontSize:13, color:"var(--fc-text-muted)", margin:"3px 0 0" }}>Update job posting details</p>
      </div>

      {error && <div style={{ padding:"12px 14px", background:"var(--fc-red-light)", border:"1px solid var(--fc-red-border)", borderRadius:10, marginBottom:16, fontSize:13, color:"#DC2626" }}>{error}</div>}

      <form onSubmit={handleSubmit}>
        <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:16, padding:24, marginBottom:14 }}>
          <h2 style={{ fontSize:14, fontWeight:700, color:"var(--fc-text-primary)", marginBottom:16, paddingBottom:10, borderBottom:"1px solid var(--fc-border-light)" }}>Basic Information</h2>
          <Field label="Job Title" required>{inp(form.jobTitle, v=>set("jobTitle",v), "Job title")}</Field>
          <Field label="Job Description" required>{ta(form.description, v=>set("description",v), "Job description...", 6)}</Field>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
            <Field label="Skills">{inp(form.skills, v=>set("skills",v), "Required skills")}</Field>
            <Field label="Experience">{inp(form.experience, v=>set("experience",v), "Experience needed")}</Field>
          </div>
          <Field label="Job Type">
            <div style={{ display:"flex", gap:6 }}>
              {JOB_TYPES.map(t => (
                <button key={t.value} type="button" onClick={()=>set("jobType",t.value)}
                  style={{ padding:"7px 16px", borderRadius:9, border:`1.5px solid ${form.jobType===t.value?"#2563EB":"var(--fc-border)"}`, background:form.jobType===t.value?"var(--fc-primary-light)":"var(--fc-card-bg)", color:form.jobType===t.value?"#2563EB":"var(--fc-text-muted)", fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                  {t.label}
                </button>
              ))}
            </div>
          </Field>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
            <Field label="Compensation">{inp(form.compensation, v=>set("compensation",v), "e.g. $80k-100k")}</Field>
            <Field label="Location">{inp(form.locationReq, v=>set("locationReq",v), "Location")}</Field>
            <Field label="Contract Length">{inp(form.contractLength, v=>set("contractLength",v), "e.g. 6 months")}</Field>
            <Field label="Closing Date">{inp(form.closingDate, v=>set("closingDate",v), "", "date")}</Field>
            <Field label="Working Hours">{inp(form.workingHours, v=>set("workingHours",v), "e.g. Mon-Fri 9-5")}</Field>
            <Field label="Benefits">{inp(form.benefits, v=>set("benefits",v), "e.g. Health, RRSP")}</Field>
          </div>
        </div>

        <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:16, padding:24, marginBottom:14 }}>
          <h2 style={{ fontSize:14, fontWeight:700, color:"var(--fc-text-primary)", marginBottom:16, paddingBottom:10, borderBottom:"1px solid var(--fc-border-light)" }}>Additional Details</h2>
          <Field label="Job Requirements">{ta(form.jobRequirements, v=>set("jobRequirements",v), "Specific requirements...")}</Field>
          <Field label="Application Details">{ta(form.applicationDetails, v=>set("applicationDetails",v), "How to apply...", 3)}</Field>
          <Field label="Other">{ta(form.other, v=>set("other",v), "Other details...", 3)}</Field>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
            <Field label="Employer Name">{inp(form.employerName, v=>set("employerName",v), "Company name")}</Field>
            <Field label="Employer Contact">{inp(form.employerContact, v=>set("employerContact",v), "Contact info")}</Field>
            <Field label="Employer Website">{inp(form.employerWebsite, v=>set("employerWebsite",v), "https://")}</Field>
          </div>
          <Field label="About Employer">{ta(form.employerDesc, v=>set("employerDesc",v), "About the company...", 3)}</Field>
        </div>

        {firmList.length > 0 && (
          <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:16, padding:24, marginBottom:14 }}>
            <h2 style={{ fontSize:14, fontWeight:700, color:"var(--fc-text-primary)", marginBottom:4, paddingBottom:10, borderBottom:"1px solid var(--fc-border-light)" }}>Firm Access</h2>
            <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginTop:10 }}>
              {firmList.map(f => {
                const fid = String(f.firm_id);
                const checked = selFirms.includes(fid);
                return (
                  <button key={fid} type="button" onClick={()=>toggleFirm(fid)}
                    style={{ display:"flex", alignItems:"center", gap:7, padding:"6px 12px", borderRadius:9, border:`1.5px solid ${checked?"#2563EB":"var(--fc-border)"}`, background:checked?"var(--fc-primary-light)":"var(--fc-card-bg)", cursor:"pointer", fontFamily:"inherit", fontSize:12, fontWeight:600, color:checked?"#2563EB":"var(--fc-text-muted)" }}>
                    <div style={{ width:16, height:16, borderRadius:4, border:`2px solid ${checked?"#2563EB":"var(--fc-text-hint)"}`, background:checked?"#2563EB":"transparent", display:"flex", alignItems:"center", justifyContent:"center" }}>
                      {checked && <i className="fa-solid fa-check" style={{fontSize:8,color:"#fff"}} />}
                    </div>
                    {f.firm_name}
                  </button>
                );
              })}
            </div>
          </div>
        )}

        <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
          <button type="button" onClick={()=>navigate(-1)} className="fc-btn fc-btn-md fc-btn-ghost fc-btn-pill">Cancel</button>
          <button type="submit" disabled={busy} className="fc-btn fc-btn-md fc-btn-primary fc-btn-pill" style={{ minWidth:130 }}>
            {busy ? <><i className="fa-solid fa-spinner fa-spin" style={{fontSize:12}} /> Saving...</> : "Save Changes"}
          </button>
        </div>
      </form>
    </div>
  );
}
